import React, { useEffect, useState } from "react";
import SideBar from "./SideBar";
import styles from "../../assets/css/admin/layout.module.css";
import { useAuth } from "../../AuthContext";
import { useSidebar } from "../../context/SidebarContext";
import api from "../../api";
import { Link } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../baseUrl";
import StatsCard from "./StatsCard";
import { Grid } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import BookIcon from '@mui/icons-material/Book';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
const Dashboard = () => {
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  const [admins,setAdmins]=useState([])
  const [students,setStudents]=useState([])
  const [courses,setCourses]=useState([])
  const [exams,setExams]=useState([])
  const deleteInvalidQuestions=()=>{
    axios.post(`${baseUrl}/utility/remove-deleted-question-from-exam`)
    .then()
    .catch(err=>console.log(err))
  }

  const fetchProtectedData = async () => {
    try {
      const { data } = await api.get("/admin/protected");
    } catch (error) {
      // logout();
      console.error("Error fetching protected data:", error);
    }
  };
  useEffect(() => {
    fetchProtectedData();
    deleteInvalidQuestions();
    api.get(`${baseUrl}/admin/count`)
      .then(res => setAdmins(res.data))
      .catch(err => console.log(err))
    axios.get(`${baseUrl}/student/count`)
      .then(res => setStudents(res.data.total))
      .catch(err => console.log(err))
    axios.get(`${baseUrl}/course/all`)
      .then(res => setCourses(res.data))
      .catch(err => console.log(err))
    axios.get(`${baseUrl}/exam/all/active`)
      .then(res => setExams(res.data.activeExams))
      .catch(err => console.log(err))
  }, []);
  return (
    <div  className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
      <aside
        className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}
      >
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
      <div style={{height:'30px'}} className="position-relative">{isSidebarOpen?<CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar}/>:<MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar}/>}</div>
      <nav aria-label="breadcrumb" className="nav">
          <ol className="breadcrumb flex-grow-1 d-flex">
            <li className="breadcrumb-item flex-grow-1">
              <Link to="/admin/dashboard" className="text-decoration-none">
                Dashboard
              </Link>
            </li>
            <li className="nav-item dropdown">
            <span
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              href=""
              role="button"
              aria-expanded="false"
            >
              Welcome, {user.name}
              <i className="ml-2 fa fa-angle-down"></i>
            </span>
            <ul className="dropdown-menu" style={{minWidth:'120px'}}>
              <li>
                <span className="dropdown-item" onClick={logout}>
                  Logout
                </span>
              </li>
            </ul>
          </li>
          </ol>

        </nav>
        <div className='container'>
          <div className="dashboard">
            <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
                <StatsCard
                  title="Admins"
                  value={admins.count}
                  icon={<AdminPanelSettingsIcon fontSize="large" />}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <StatsCard
                  title="Students"
                  value={students}
                  icon={<PeopleIcon fontSize="large" />}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <StatsCard
                  title="Courses"
                  value={courses.length}
                  icon={<BookIcon fontSize="large" />}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <StatsCard
                  title="Active Exams"
                  value={exams.length}
                  icon={<AssignmentIcon fontSize="large" />}
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
